<div class="usa-modal__content">
    <div class="usa-modal__main">
        <h2 class="usa-modal__heading" id="modal-1-heading">
            {{title ? title : 'Confirmation'}}
        </h2>
        <div class="usa-prose">
            <p id="modal-1-description">{{question}}</p>
            <p id="modal-1-description" [innerHTML]="body"></p>
        </div>
        <div class="usa-modal__footer">
            <div class="grid-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <ul class="usa-button-group">                        
                        <li class="usa-button-group__item" *ngIf="cancelText">
                            <button type="button" title="{{cancelText}}" type="button" class="usa-button usa-button--outline" (click)="makeSelection(false)">{{cancelText}}</button>
                        </li>
                        <li class="usa-button-group__item">
                            <button type="button" title="{{confirmText}}" type="button" class="usa-button" (click)="makeSelection(true)">{{confirmText}}</button>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <button *ngIf="!hideCloseButton" class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="bsModalRef.hide();makeSelection('hide')">
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>